// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_Dc8","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_Mz6 StatelessWorkCardsUpsellModal-styles-cls1_Dc8"};